import React from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

import { TextField } from 'formik-material-ui';
import { Button, Grid } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';

import NavBar from '../components/navbar'
import SignupSidebar from '../components/sidebarSignup'

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
        margin: theme.spacing(3),
        width: '25ch',
        },
    },
}));

const ColorButton = withStyles((theme) => ({
root: {
    color: theme.palette.getContrastText('#29479a'),
    backgroundColor: '#29479a',
    width: 'auto', 
    minWidth: '150px',
    borderRadius: '25px',
    marginBottom: '50px',
    '&:hover': {
    backgroundColor: '#294780',
    },
},
}))(Button);

const SignupSchema = Yup.object().shape({
    name: Yup.string()
        .min(2, 'Too Short!')
        .max(50, 'Too Long!')
        .required('Required'),
    company: Yup.string()
        .min(2, 'Too Short!')
        .max(50, 'Too Long!')
        .required('Required'),
    title: Yup.string()
        .min(3, 'Too Short!')
        .max(50, 'Too Long!')
        .required('Required'),
    interest: Yup.string()
        .min(3, 'Too Short!')
        .max(50, 'Too Long!')
        .required('Required'),
    phone: Yup.number().required('Required'),
    email: Yup.string().email('Invalid email').required('Required'),
});

const ClientSignup = (props) => {
    const classes = useStyles();

    return (
        <>
        <NavBar type='main'/>
        <Grid 
        container 
        spacing={2}>
            <Grid 
            item xs={12} sm={4} lg={4}
            direction='row' 
            justify='center' 
            alignItems='center'>
                <SignupSidebar content='One Step Away From Building Your Team'/>
            </Grid>
            <Grid 
            item xs={12} sm={8} 
            direction='row' 
            justify='center' 
            alignItems='center'>
                <Formik
                initialValues={{
                    name: '',
                    email: '',
                    company: '',
                }}
                validationSchema={SignupSchema}
                onSubmit={(values, { setSubmitting }) => {
                    setTimeout(() => {
                      setSubmitting(false);
                      alert(JSON.stringify(values, null, 2));
                    }, 500);
                  }}>
                {({ submitForm, isSubmitting }) => (
                <Form className={classes.root} >
                    <Grid 
                    container 
                    direction='row' 
                    justify='center' 
                    alignItems='center'
                    style={{marginTop: 40}}>
                        <Grid 
                        container 
                        item 
                        direction='row' 
                        justify='center' 
                        alignItems='center'>
                            <Field 
                            name='name'
                            component={TextField}
                            id="standard-required" label="Name" />
                            <Field 
                            name='email'
                            component={TextField}
                            id="standard-required" label="Email" />
                        </Grid>
                    </Grid>
                    <Grid 
                    container 
                    direction='row' 
                    justify='center' 
                    alignItems='center'
                    style={{marginTop: 40}}>
                        <Grid
                        container 
                        item 
                        direction='row' 
                        justify='center' 
                        alignItems='center'>
                            <Field 
                            name='company'
                            component={TextField}
                            id="standard-required" label="Company Name" />
                            <Field 
                            name='phone'
                            component={TextField} 
                            id="standard-required" label="Phone Number" />
                        </Grid>
                    </Grid>
                    <Grid 
                    container 
                    direction='row' 
                    justify='center' 
                    alignItems='center'
                    style={{marginTop: 40}}>
                        <Grid
                        container 
                        item 
                        direction='row' 
                        justify='center' 
                        alignItems='center'>
                            <Field
                            name='title'
                            component={TextField}
                            id="standard-helperText"
                            label="Title" helperText="your postition at the company"/>
                            <Field
                            name='interest'
                            component={TextField}
                            id="standard-helperText"
                            label="Interest"
                            helperText="what are you interested at"/>
                        </Grid>
                        </Grid>
                    <Grid 
                    container 
                    direction='row' 
                    justify='center' 
                    alignItems='center'
                    style={{marginTop: 40}}>
                        <Grid
                        container 
                        item xs={6} 
                        direction='row' 
                        justify='center' 
                        alignItems='center'>
                            <ColorButton
                            disabled={isSubmitting}
                            onClick={submitForm}>
                                submit
                            </ColorButton>
                        </Grid>
                    </Grid>
                </Form>
                )}
                </Formik>
            </Grid>
        </Grid>
        </>
    );
}
 
export default ClientSignup;
